import { NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';
import { FooterComponent } from './components/common/footer/footer.component';

import { HomeComponent } from './components/pages/home/home.component';
import { TextsDataService } from './services/texts-data.service';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertsComponent } from './components/common/alerts/alerts.component';
import { AlertService } from './services/alerts.service';
import { ChatLayoutAssistanceComponent } from './components/common/chat-layout-assistance/chat-layout-assistance.component';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { MatStepperModule } from '@angular/material/stepper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { ChatTasaLayoutAssistanceComponent } from './components/pages/chat-tasa-layout-assistance/chat-tasa-layout-assistance.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';

@NgModule({
    declarations: [
        AppComponent,

        /* Componentes Paginas */
        HomeComponent,
        ErrorPageComponent,
        ChatTasaLayoutAssistanceComponent,

        /* Componentes comunes */
        NavbarComponent,
        FooterComponent,
        AlertsComponent,
        ChatLayoutAssistanceComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ReactiveFormsModule,

        NoopAnimationsModule,
        CdkStepperModule,
        MatStepperModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatButtonModule,
        MatTooltipModule,
        MatSelectModule,
        MatIconModule,
        MatSnackBarModule,
        MatInputModule,
        MatCheckboxModule,
        MatOptionModule,
        MatDialogModule,

        SweetAlert2Module.forRoot(),
    ],
    providers: [
        TextsDataService,
        AlertService,

        MatIconRegistry,
        provideAnimationsAsync(),
        CookieService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
        matIconRegistry.setDefaultFontSetClass('material-icons');
    }
}
